import { createSelector } from 'reselect';
import { UIFilterStarterKindType } from '../model/ChatStarterModel';
import { ChatStartersStateType } from '../reducers/chatStarters';
import { StoreState } from '../store-interfaces';
import { selectInstagramAccountId } from './instagramSelectors';

const selectStarters = (state: StoreState) => state.chatStarters;

const selectChatStarterUiFilterKind = (
  _,
  starterKind: UIFilterStarterKindType | undefined,
) => starterKind;

const getStarterRecordsByUiFilterKind = (
  starters: ChatStartersStateType,
  starterKind?: UIFilterStarterKindType,
) => {
  const kindToGet = starterKind || 'all';
  return starters.records[kindToGet];
};

export const selectChatStartersInvalidRecords = createSelector(
  [selectStarters],
  starters => starters.invalidRecords,
);

export const selectAllChatStarterRecords = createSelector(
  [selectStarters],
  starters => starters.records.all?.chatStarters,
);

export const selectChatStarterRecordsByUiFilterKind = createSelector(
  [selectStarters, selectChatStarterUiFilterKind],
  getStarterRecordsByUiFilterKind,
);

export const selectChatStartersCountByUiFilterKind = (
  state: StoreState,
  kind: UIFilterStarterKindType,
) => {
  const instagramAccountId = selectInstagramAccountId(state);
  if (
    (kind === 'instagram_welcomer' ||
      kind === 'instagram_story_mention' ||
      kind === 'instagram_story_reaction' ||
      kind === 'instagram_comment_guard') &&
    !instagramAccountId
  ) {
    return 0;
  }
  const recordByKind = selectChatStarterRecordsByUiFilterKind(state, kind);

  const countByKind = recordByKind?.pagination.total;
  const count: number | undefined = state?.chatStarters?.counters?.[kind];

  return count || countByKind;
};
